// =============================================================================
// Copyright   : 2018 semantics GmbH
// Date        : $Date: 2025-04-29 22:05:21 +0200 (Tue, 29 Apr 2025) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: o.powroznik $
// Revision    : $Rev: 152034 $
// Purpose     : some examples and some whiteboard space for /test/whiteboard
// =============================================================================
// ---Third-party imports
import clsx from 'clsx'
import React, {useState, useEffect, useMemo} from 'react'

// ---Local imports
import S from './index.scss'
import {Button} from './button'

// ---Exports
export {Button, ButtonGroup} from './button'
export {TextTicker} from './textTicker'
export {TextTickerSelection} from './textTickerPicker'
export {AudioTicker, AudioWaves} from './audioticker'
export {Showcase} from './showcase'
export {SlideIndicator} from './slideIndicator'
export {AiPrompt, AiImage} from './ai'
export {PageViewer} from './pageViewer'
export {Modal} from './modal'
export {MediaPlayer} from './mediaplayer'

export const GhostText = ({className, fontSize = '1rem', lines = 8, style}) => {
  let lineStyles = useMemo(() => {
    return Array.from({length: lines}).map(() => ({
      width: `${Math.floor(Math.random() * 51) + 50}%`,
      height: fontSize,
    }))
  }, [lines, fontSize])

  return (
    <div style={style} className={clsx(className, S.placeholder)}>
      {lineStyles.map((style, i) => (
        <div key={i} className={S.line} style={style} />
      ))}
    </div>
  )
}

export const GhostImage = ({width = '160px', height = '320px', style}) => {
  return (
    <div
      className={clsx(S.placeholder, S.image)}
      style={{width: width, height: height, ...style}}
    ></div>
  )
}

export const AccessWarning = ({children, awstate, id, onClick}) => {
  if (!awstate) return <>{children}</>
  let [revealed, setRevealed] = useState(false)
  useEffect(() => {
    setRevealed(!awstate)
  }, [awstate, id])

  let onClickHandler = () => {
    setRevealed(true)
    if (onClick) {
      onClick()
    }
  }
  const accessWariningText = !revealed ? (
    <div className={S.sensitiveOverlay}>
      Dieses Bild enthält sensible Inhalte, die für manche Betrachter:innen verstörend oder
      unangemessen sein könnten.
      {!onClick ? (
        <Button
          size="small"
          inverted
          bordered
          content="Klicken um anzuzeigen"
          circle={false}
          onClick={onClickHandler}
        />
      ) : (
        <>
          <br />
          <br />
          Klicken um anzuzeigen
        </>
      )}
    </div>
  ) : null

  return (
    <div
      onClick={onClick && onClickHandler}
      className={clsx(S.img, !revealed && S.accessWariningContent)}
    >
      {accessWariningText}
      <div id="AccessWarning" className={clsx(!revealed && S.blured)}>
        {children}
      </div>
    </div>
  )
}
